import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DashboardLayout from "@/components/DashboardLayout";
import api from "@/lib/api";
import { Plane } from "lucide-react";

const STATUS_PILL = {
  Submitted: "as-pill-blue", "Under Review": "as-pill-blue",
  "In Planning": "as-pill-orange", "Awaiting Client Confirmation": "as-pill-orange",
  Confirmed: "as-pill-gold", "In Progress": "as-pill-gold",
  Completed: "as-pill-green", Cancelled: "as-pill-red", Draft: "as-pill-muted",
};

export default function PortalTrips() {
  const [trips, setTrips] = useState([]);
  useEffect(() => { api.get("/trips").then(r => setTrips(r.data)); }, []);
  return (
    <DashboardLayout role="client">
      <div className="max-w-[1200px] mx-auto px-8 py-10">
        <div className="flex items-end justify-between mb-8">
          <div>
            <div className="as-overline">My Trips</div>
            <h1 className="as-serif text-5xl font-light mt-2" data-testid="portal-trips-title">Missions</h1>
          </div>
          <Link to="/portal/trips/new" className="as-btn-gold px-5 py-3 rounded-sm as-mono text-[10px] uppercase tracking-[0.2em]" data-testid="trips-new">+ New Trip Request</Link>
        </div>
        <div className="as-card divide-y divide-[#E5DFD2]" data-testid="portal-trips-list">
          {trips.length === 0 && <div className="p-10 text-center text-[#756E64]">No trips yet.</div>}
          {trips.map(t => (
            <Link key={t.id} to={`/portal/trips/${t.id}`} className="p-6 flex items-center justify-between hover:bg-white transition-colors block" data-testid={`trip-row-${t.id}`}>
              <div className="flex items-center gap-6">
                <Plane size={16} className="as-gold"/>
                <div>
                  <div className="as-serif text-2xl font-light">{t.legs?.[0]?.departure_airport} <span className="as-gold">→</span> {t.legs?.[0]?.arrival_airport}</div>
                  <div className="text-xs as-mono text-[#756E64] mt-1">{new Date(t.legs?.[0]?.departure_datetime).toUTCString().slice(0,22)} · {t.aircraft_preference || "Aircraft TBD"}</div>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className={`as-pill ${STATUS_PILL[t.status] || "as-pill-muted"}`}>{t.status}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
}
